import React from "react";
import { useSelector } from "react-redux";
import { selectLiveWorkspaces } from "../selectors/liveWorkspaces.selector";
import { LiveWorkspace } from "./live.workspace";

export const LiveWorkspacesContainer = () => {
  const liveWorkspaces = useSelector(selectLiveWorkspaces);

  return (
    <div>
      {liveWorkspaces.map((liveWorkspace) => (
        <LiveWorkspace key={liveWorkspace.workspaceId} {...liveWorkspace} />
      ))}
    </div>
  );
};
